import React from 'react'
import { useEffect } from 'react'
import "./relation.css"


function Relation() {

    useEffect(() => {
        window.scroll(0,0)
    }, [])

    return (
        <div className="contenu">
            <div className="sidePhoto relation">
            </div>
            <div id="textRelation">
                <h2>Relations presse et partenaires</h2>
                <div className="parag">
                    <h3>Relation presse</h3>
                    <p>Nous <strong>développons</strong> vos <strong>relations</strong> avec les <strong>médias</strong> pour vous faire connaitre, faire parler de vos activités, vos actions et vos événements dans la presse écrite, à la télévision ainsi qu’à la radio.</p>
                </div>
                <div className="parag"><h4>Avec comme principaux objectifs :</h4>
                    <ul>
                        <li><strong>Mettre en valeur</strong> votre domaine d’<strong>expertise</strong></li>
                        <li>Donner envie aux <strong>participants</strong> et au <strong>grand public</strong> de <strong>se déplacer sur vos manifestations</strong></li>
                        <li><strong>Faire connaitre</strong> les <strong>possibilités offertes</strong> à vos clients et adhérents</li>
                        <li><strong>Mettre en valeur</strong> vos <strong>partenaires</strong> privés et publics</li>
                        <li><strong>Faire connaitre</strong> vos <strong>valeurs</strong> et vos <strong>actions</strong></li>
                    </ul>
                    <p>Le tout grâce à l’envoi de <strong>communiqués de presse</strong>, la création d’un <strong>dossier de presse</strong>, l’organisation d’une <strong>conférence de presse</strong> et <strong>l’accueil des médias</strong> sur vos événements. </p>
                </div>
                <div className="parag"><h3>Relation partenaires</h3>
                    <p>Nous sommes à vos côtés pour <strong>renforcer les relations avec vos partenaires</strong> actuels ou vous <strong>mettre en relation</strong> avec de nouveaux prêts à s’investir dans vos projets.</p>
                    <h4>Vous êtes sportif de haut niveau</h4>
                    <p>Nous <strong>gérons votre image</strong> en vous créant une notoriété autant dans le milieu sportif qu'auprès du grand public. L'agence s'occupe également de vous <strong>mettre en relation avec des sponsors et partenaires</strong>.</p>
                    <h4>Vous cherchez à mettre en valeur l'image de votre entreprise</h4>
                    <p>Nous vous <strong>mettons en relation</strong> avec des <strong>sportifs de haut niveau</strong> porteurs de <strong>valeurs fortes</strong>.</p>
                </div>
            </div>
        </div>
    )
}

export default Relation
